import { Types } from './types'

const initialState = {
    dataService: {
        rows: [],
        paging: {}
    },
}
const reducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_SERVICE:
            return {
                ...newState,
                dataService: action.payload
            }
        default:
            return { ...newState }
    }
}
export default reducer
